<template>
  <v-card class="modal grey700">
    <v-card-text class="pt-8 grey800 text-center">
      <v-progress-circular
        v-if="!popupBlocked" class="mb-4" color="primary500" indeterminate
        size="48"
      />
      <fai v-else class="primary500--text display-2 mb-4" :icon="['fas','exclamation-triangle']" />

      <h2
        v-t="popupBlocked ? 'page.auth.popup.blocked.title' : 'page.auth.title'" class="title mb-2"
        :class="{'error--text': popupBlocked}"
      />

      <p v-if="!popupBlocked" v-t="'page.auth.popup'" class="mb-5" />

      <i18n v-else path="page.auth.popup.blocked" tag="p" class="mb-5">
        <a v-t="'cta.click_here'" :href="authUrl" class="link primary500--text font-weight-bold" />
      </i18n>

      <v-alert
        transition="scale-transition" :value="!popupBlocked && showAlert" class="py-3" dense
        color="grey600"
      >
        <h3 v-t="'page.auth.timeout.title'" class="text-body-2 font-weight-bold mb-1" />
        <i18n path="page.auth.timeout" tag="p" class="text-caption mb-0">
          <a v-t="'cta.click_here'" :href="authUrl" class="link primary500--text font-weight-bold" />
        </i18n>
      </v-alert>

      <p v-t="'page.auth.terms'" class="text-caption text--secondary" />
    </v-card-text>
    <v-card-actions class="flex-center">
      <v-btn v-t="'cta.cancel'" text small @click="close" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { CenteredPopup } from '@/utils'
import { mapActions } from 'vuex'

export default {
  props: {
    close: {
      type: Function,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      popupBlocked: false,
      showAlert: false,
    }
  },
  computed: {
    authUrl() {
      return this.payload?.authUrl ?? null
    },
    provider() {
      return this.payload?.provider ?? null
    },
  },
  async mounted() {
    setTimeout(() => {
      this.showAlert = true
    }, 2e3)

    await this.openPopupWindow(this.authUrl)
  },
  methods: {
    ...mapActions({
      getConnections: 'user/getConnections',
    }),
    async openPopupWindow(url) {
      if (!url) return

      try {
        const popup = CenteredPopup(url, 'Authentication', 800, 600)
        popup.focus()
      } catch (e) {
        this.popupBlocked = true
        return
      }

      try {
        const msg = await this.popupWaiter()
        if (!msg.success) throw new Error(msg.error)

        await this.getConnections()

        // TODO big fucking yikes btw
        if (this.provider === 'discord') {
          const win = window.open('https://discord.gg/banditcamp', '_blank')
          if (win) win.focus()
        }

        this.close()
      } catch (err) {
        this.$toast.error(err.message)
      }
    },
    async popupWaiter() {
      return new Promise((res, rej) => {
        const handler = ({ data }) => {
          if (data.source !== 'oauth') return

          res(data)
          window.removeEventListener('message', handler)
        }

        setTimeout(() => {
          window.removeEventListener('message', handler)
          rej(new Error('TimedOut')) // TODO move to constants
        }, 60e3)

        window.addEventListener('message', handler)
      })
    },
  },
}

</script>
